import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleEditModalView } from 'shared/store/features/editWorkOrderModalSlice';
import { RootState } from 'shared/store/rootReducer';
import { unarchiveWorkOrders } from 'shared/api/workOrders';
import { setSelectedWorkOrders } from 'shared/store/features/workOrdersTableSlice';
import WorkOrder from 'shared/interfaces/WorkOrder.interface';
import { updateArchiveStatusOfMany } from 'shared/store/features/workOrdersSlice';
import { closeAlert, setAlert } from 'shared/store/features/alertSlice';
import { setArchiveFilterStatus } from 'shared/store/features/archiveFilterStatusSlice';
import { ArchiveStatus } from 'App/BillingDashboard/filterOptions.enum';

const useEditBarLogic = () => {
  const dispatch = useDispatch();
  const selectedWorkOrders = useSelector(
    (state: RootState) => state.workOrdersTable.selectedWorkOrders
  );
  const { archiveFilterStatus } = useSelector(
    (state: RootState) => state.archiveFilterStatus
  );
  const [isLoading, setIsLoading] = useState(false);

  const setIsEditWorkOrderModalOpened = useCallback((isEditWorkOrderModalOpened: boolean) => {
    dispatch(toggleEditModalView({ isEditWorkOrderModalOpened }));
  }, [dispatch]);

  const onUnarchiveSubmit = () => {
    setIsLoading(true);
    const ids = selectedWorkOrders.map(WO => (WO.id));
    unarchiveWorkOrders(ids)
      .then((data: WorkOrder[]) => {
        dispatch(updateArchiveStatusOfMany({
          isArchived: true,
          ids: data.map(wo => wo.id),
          archiveReason: ''
        }));
        dispatch(setAlert({
          text: 'Work order was restored',
          variant: 'success',
          open: true,
          onClickButton: () => {
            dispatch(setArchiveFilterStatus({ archiveFilterStatus: ArchiveStatus.active }));
            dispatch(closeAlert());
          },
          onClickButtonLabel: 'Show Active Work Orders'
        }));
      })
      .catch((error: any) => dispatch(setAlert({
        text: error.message,
        variant: 'danger',
        open: true
      })))
      .finally(() => {
        setIsLoading(false);
        dispatch(setSelectedWorkOrders({ selectedWorkOrders: [] }));
      });
  };

  return {
    isLoading,
    selectedWorkOrders,
    archiveFilterStatus,
    setIsEditWorkOrderModalOpened,
    onUnarchiveSubmit
  };
};

export default useEditBarLogic;
